import TableWithPagination from './index.vue';
import tablePaginationMixin from './tablePaginationMixin';
export default TableWithPagination;

export {tablePaginationMixin as TablePaginationMixin};
